export enum EMarketComponentItems {
  TOP_PICK = 'TOP_PICK',
  TOP_GAINER = 'TOP_GAINER',
  TOP_LOSER = 'TOP_LOSER',
  FAVOURITES = 'MY_WATCHLIST',
  ALL = 'ALL',
  POSITIONS = 'POSITIONS',
  SIGNALS = 'SIGNALS'
}
